/**
 * Shared formatting helpers used across pages (Dashboard, Reports, etc.).
 *
 * en-GB pinned everywhere so the same date renders identically on every
 * screen (previously local formatDate reimplementations had mixed locales).
 * Minor-unit money formatting with full symbol support lives in
 * utils/money.js - formatCurrency here keeps its legacy signature.
 */

import { formatDateKey } from './dates';

const GB = 'en-GB';
const CURRENCY_SYMBOLS = { GBP: '£', EUR: '€', USD: '$' };

export function formatCurrency(minorUnits, currency = 'GBP') {
  const amount = (minorUnits || 0) / 100;
  return `${CURRENCY_SYMBOLS[currency] || ''}${amount.toLocaleString(GB)}`;
}

export function formatDate(value) {
  if (!value) return '-';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleDateString(GB, { day: 'numeric', month: 'short', year: 'numeric' });
}

export function formatTime(value) {
  if (!value) return '-';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleTimeString(GB, { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/London' });
}

export function formatDateTime(value) {
  if (!value) return '-';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return `${formatDate(date)}, ${formatTime(date)}`;
}

// Report trends bucket rows by DATE_TRUNC('month', ...), which the API sends
// as the 1st at midnight UTC. Label the month it names: read with
// new Date() it was the evening before west of UTC, so a month early.
export function formatMonth(dateString) {
  return formatDateKey(dateString, { month: 'short', year: '2-digit' });
}

// For datetime-local inputs. toISOString() alone renders UTC, which shifts
// every prefilled time by an hour during BST — always go through this.
export function toLocalDateTimeInput(value = new Date()) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const offsetMs = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offsetMs).toISOString().slice(0, 16);
}
